import { Button, ButtonGroup } from "reactstrap";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { GetLanguageString } from "../../../helper/Components";
import { GetCustomStyles } from "../../../helper/Method";

const IncomeReportExportButtons = ({
  onExcel,
  onPdf,
  disabled = false,
}) => {
  return (
    <ButtonGroup className={GetCustomStyles().btn_style}>
      <Button
        color="default"
        size="sm"
        onClick={onExcel}
        disabled={disabled}
        style={{ marginRight: 3, marginBottom: 1 }}
      >
        <RiFileExcel2Line
          size={15}
          color="#009440"
          style={{ marginRight: 3, marginBottom: 1 }}
        />
        {<GetLanguageString props="member_report_export_excel" />}
      </Button>
      <Button color="default" size="sm" onClick={onPdf} disabled={disabled}>
        <RiFilePdf2Line
          size={15}
          color="#FF0000"
          className={GetCustomStyles().fa_style}
        />
        {<GetLanguageString props="member_report_export_pdf" />}
      </Button>
    </ButtonGroup>
  );
};

export default IncomeReportExportButtons;
